type Props = {
  progress: number;
  error?: string | null;
};

export const ModelLoader = ({ progress, error }: Props) => {
  return (
    <div className="rounded-xl border border-background-border bg-background-surface p-4 text-center">
      <p className="text-sm font-semibold text-text-primary">Preparing engagement engine</p>
      <div className="mt-4 h-2 rounded-full bg-background-border">
        <div className="h-full rounded-full bg-neon-gradient transition-all" style={{ width: `${Math.round(progress * 100)}%` }} />
      </div>
      <p className="mt-2 text-xs text-text-dimmed">
        Loading TensorFlow.js + emotion model ({Math.round(progress * 100)}%)
      </p>
      {error && <p className="mt-2 text-xs text-neon-red">{error}</p>}
    </div>
  );
};

